module.exports = __webpack_public_path__ + "img/icon_dianpu_LUBAN.16b96632.png";